/// <reference types="../node_modules/@types/jquery" />

import * as $ from 'jquery';
import * as ko from 'knockout';

class Localization {
    durationText1M: string;
    durationText2M: string;
    durationText3M: string;
    durationText4M: string;
    durationText5M: string;
    durationText6M: string;
    durationText7M: string;
    durationText8M: string;
    durationText9M: string;
    durationText10M: string;
    durationText11M: string;
    durationText12M: string;
    durationTextFormat: string;
    priceErrorMessageFormat: string;
    orderErrorMessageFormat: string;
}

class ApiEndpoints {
    getCurrencies: string;
    getPricing: string;
    calcPrice: string;
    createOrder: string;
}

class OrderEditorSettings {
    currency: string;
    endpoints: ApiEndpoints;
    localization: Localization;
}

class DurationOption {
    constructor(public days: number, public title: string, public text: string) { }

    static get(settings: OrderEditorSettings): DurationOption[] {
        return [
            DurationOption.create(1 * 30, settings.localization.durationText1M, settings),
            DurationOption.create(2 * 30, settings.localization.durationText2M, settings),
            DurationOption.create(3 * 30, settings.localization.durationText3M, settings),
            DurationOption.create(4 * 30, settings.localization.durationText4M, settings),
            DurationOption.create(5 * 30, settings.localization.durationText5M, settings),
            DurationOption.create(6 * 30, settings.localization.durationText6M, settings),
            DurationOption.create(7 * 30, settings.localization.durationText7M, settings),
            DurationOption.create(8 * 30, settings.localization.durationText8M, settings),
            DurationOption.create(9 * 30, settings.localization.durationText9M, settings),
            DurationOption.create(12 * 30, settings.localization.durationText12M, settings)
        ];
    }

    private static create(days: number, title: string, settings: OrderEditorSettings): DurationOption {
        return new DurationOption(
            days,
            title,
            settings.localization.durationTextFormat.replace('%title%', title).replace('%days%', days.toString()));
    }
}

class Currency {
    code: string;
    symbol: string;
    name: string;
    rate: number;

    static getText(c: Currency): string {
        return c.name + ' (' + c.code + ')';
    }

    static get(settings: OrderEditorSettings): Promise<Currency[]> {
        //var promise: Promise<Currency[]> =  $.getJSON(settings.endpoints.getCurrencies);}
        // todo временный фикс, оставили только рубли.
        var promise: Promise<Currency[]> = new Promise(
            (resolve, reject) => {
                resolve([{ code: 'RUB', symbol: '₽', name: 'RUB', rate: 1 }]);
            }
        );
        return promise;
    }
}

class PriceInfo {
    p: number;
    c: string;
}

class ComponentInfo extends PriceInfo {
    id: string;
    name: string;
    descr: string;
}

class PricingInfo {
    productName: string;
    basePrice: PriceInfo;
    components: ComponentInfo[];

    static get(settings: OrderEditorSettings): Promise<PricingInfo> {
        var promise: Promise<PricingInfo> = $.getJSON(settings.endpoints.getPricing);
        return promise;
    }
}

class Feature {
    constructor(component: ComponentInfo) {
        this.id = component.id;
        this.name = component.name;
        this.description = component.descr;
        this.priceValue = component.p;
        this.priceCurrency = component.c;
        this.isFree = component.p <= 0;

        this.isAlwaysSelected(component.p <= 0);
        this.isSelected(true);
    }

    id: string;
    name: string;
    description: string;
    priceValue: number;
    priceCurrency: string;
    price = ko.observable<string>();
    isFree: boolean;
    isAlwaysSelected = ko.observable<boolean>(true);
    isSelected = ko.observable<boolean>(true);
}

function validateEmail(input: string): boolean {
    const pattern = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
    return pattern.test(input);
}

class OrderEditorViewModel {
    constructor(private settings: OrderEditorSettings) {
        this.initDuration();
        this.initEmail();

        $.when(this.initCurrency(), this.initPricing()).then(() => this.isBusy(false));
    }

    //#region Duration

    durations = ko.observableArray<DurationOption>();
    duration = ko.observable<DurationOption>();

    private initDuration() {
        this.durations(DurationOption.get(this.settings));
        this.duration(this.durations()[0]);
    }

    //#endregion

    //#region Currency

    currencies = ko.observableArray<Currency>();
    currency = ko.observable<Currency>();
    exchangeRate = ko.pureComputed(() => this.getExchangeRateText());
    private currencyByCode = <{ string: Currency }>{};

    private initCurrency(): Promise<any> {
        return Currency.get(this.settings)
            .then(values => {
                this.currencies(values);
                this.currency(this.currencies()[0]);
                for (var i in values) {
                    var c = values[i];
                    this.currencyByCode[c.code] = c;
                }

                this.currency(this.currencyByCode[this.settings.currency] || this.currencies()[0]);
            })
            .catch(err => {
                this.showError(err.message);
            });
    }

    private getExchangeRateText(): string {
        var currency = this.currency();
        if (!currency || currency.code === this.settings.currency) {
            return '';
        }

        return this.settings.currency + '/' + currency.code + ' = ' + currency.rate;
    }

    //#endregion

    //#region Email

    email = ko.observable<string>();
    isEmailValid = ko.pureComputed<boolean>(() => validateEmail(this.email()));

    private initEmail() {
    }

    //#endregion

    //#region Pricing

    private basePriceValue: number;
    private basePriceCurrency: string;
    basePrice = ko.observable<string>();
    features = ko.observableArray<Feature>();
    isPriceCalcInProgress = ko.observable<boolean>(false);
    isCurrencyRub = ko.observable<boolean>(true);
    totalPrice = ko.observable<string>();
    totalPriceError = ko.observable<string>();
    hasTotalPriceError = ko.observable<boolean>(false);
    private totalPriceValue: number;
    private totalPriceCurrency: string;
    private recalcPricePromise: Promise<any> = null;

    private initPricing(): Promise<any> {
        this.currency.subscribe(() => this.recalcPrice());
        this.duration.subscribe(() => this.recalcPrice());
        return PricingInfo.get(this.settings)
            .then(info => {
                this.productName(info.productName);
                this.basePriceValue = info.basePrice.p;
                this.basePriceCurrency = info.basePrice.c;

                for (var i in info.components) {
                    var feature = new Feature(info.components[i]);
                    this.features.push(feature);
                    feature.isSelected.subscribe(() => this.recalcPrice(false));
                };

                this.recalcPrice();
            })
            .catch(err => {
                this.showError(err.message);
            });
    }

    recalcPrice(force: boolean = true) {
        if (!force) {
            this.isPriceCalcInProgress(true);
            setTimeout(() => this.recalcPrice(), 500);
            return;
        }

        if (this.recalcPricePromise) {
            this.recalcPricePromise = this.recalcPricePromise.then(() => this.recalcPriceImpl());
        } else {
            this.recalcPricePromise = this.recalcPriceImpl();
        }
    }

    private recalcPriceImpl(): Promise<any> {
        var currency = this.currency();
        var duration = this.duration();
        if (!currency || !duration) {
            this.basePrice('');
            this.totalPrice('');
            return Promise.resolve({});
        }

        var license = {
            features: [],
            period: duration.days,
            email: this.email(),
            currency: currency.code
        };

        var basePrice = this.convertPrice(this.basePriceValue, this.basePriceCurrency, currency);
        this.basePrice(this.formatPrice(basePrice, currency));

        var features = this.features();
        for (var i in features) {
            var feature = features[i];
            var featurePrice = this.convertPrice(feature.priceValue, feature.priceCurrency, currency);
            feature.price(this.formatPrice(featurePrice, currency));
            if (feature.isSelected()) {
                license.features.push(feature.id);
            }
        }

        this.isPriceCalcInProgress(true);
        this.hasTotalPriceError(false);

        return $.ajax({
            url: this.settings.endpoints.calcPrice,
            data: JSON.stringify(license),
            contentType: 'application/json',
            type: 'POST'
        })
            .done((resp) => {
                this.totalPriceValue = resp.price;
                this.totalPriceCurrency = currency.code;
                this.totalPrice(this.formatPriceStr(resp.price, resp.currency));
                this.isCurrencyRub(true);
                if (currency.code !== 'RUB') {
                    this.isCurrencyRub(false);
                }
            })
            .fail((e) => {
                var msg = this.settings.localization.priceErrorMessageFormat
                    .replace('%message%', e.status + ' ' + e.statusText);
                this.totalPriceError(msg);
                this.hasTotalPriceError(true);
            })
            .always(() => {
                this.isPriceCalcInProgress(false);
            });
    }

    private convertPrice(price: number, sourceCurrency: string, targetCurrency: Currency): number {
        if (sourceCurrency === targetCurrency.code) {
            return price;
        }

        return price * targetCurrency.rate;
    }

    private formatPriceStr(price: number, currencyCode: string): string {
        if (price <= 0) {
            return '-';
        }

        var currency = this.currencyByCode[currencyCode] || { code: currencyCode };

        if (currency.code === 'RUB') {
            return price + '&nbsp;' + currency.symbol;
        }
        if (currency.symbol) {
            return currency.symbol + price;
        }
        return price + ' ' + currency.code;
    }

    private formatPrice(price: number, currency: Currency): string {
        if (price <= 0) {
            return '-';
        }

        price = Math.round(price * 100.0) / 100.0;

        if (currency.code === 'RUB') {
            return price + '&nbsp;' + currency.symbol;
        }
        if (currency.symbol) {
            return currency.symbol + price;
        }
        return price + ' ' + currency.code;
    }

    //#endregion

    //#region ViewState

    productName = ko.observable<string>('OptionWorkshop');
    isBusy = ko.observable<boolean>(true);
    hasError = ko.observable<boolean>(false);
    errorText = ko.observable<string>();

    private showError(msg: string) {
        this.hasError(true);
        this.errorText(msg);
    }

    //#endregion

    //#region Order

    isOrderInProgress = ko.observable<boolean>(false);
    isOrderSuccessful = ko.observable<boolean>(false);
    orderNum = ko.observable<string>();
    paymentType = ko.observable<string>();

    makeOrder(paymentType: string) {
        var currency = this.currency();
        var duration = this.duration();
        if (!currency || !duration || !this.isEmailValid() || (paymentType === 'CloudPayments' && currency.code !== 'RUB')) {
            return;
        }

        var license = {
            features: [],
            period: duration.days,
            email: this.email(),
            currency: currency.code,
            paymentType: paymentType
        };

        var features = this.features();
        for (var i in features) {
            var feature = features[i];
            if (feature.isSelected()) {
                license.features.push(feature.id);
            }
        }

        this.isOrderInProgress(true);
        this.isOrderSuccessful(false);
        this.paymentType(paymentType);

        $.ajax({
            url: this.settings.endpoints.createOrder,
            data: JSON.stringify(license),
            contentType: 'application/json',
            type: 'POST'
        })
            .done((resp) => {
                this.isOrderSuccessful(true);
                this.orderNum(resp.orderNum);
            })
            .fail((e) => {
                var msg = this.settings.localization.orderErrorMessageFormat
                    .replace('%message%', e.status + ' ' + e.statusText);
                this.showError(msg);
            })
            .always(() => {
                this.isOrderInProgress(false);
            });
    }

    //#endregion
}

export default function createOrderEditor(element: HTMLElement, settings: OrderEditorSettings) {
    var viewModel = new OrderEditorViewModel(settings);
    ko.applyBindingsToDescendants(viewModel, element);
}

const OrderEditor = {
    create: createOrderEditor,
    Currency: Currency,
};

window['createOrderEditor'] = createOrderEditor;
window['OrderEditor'] = OrderEditor;